import React, { Component } from "react";
import footerDataCollections from "./data/FooterData"
export default class ColmunFooter extends Component {
  render() {
    return (
      <>
        {this.props.data.map(({ title, links }, i) => (
          <div key={i}>
            <h3>{title}</h3>

            <ul>
              {links.map(({ text, URL }, i) => {
                return (
                  <li key={i}>
                    <a href={URL}>{text}</a>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </>
    );
  }
}
